<template>
  <div class="work-panel">
    <div class="work-panel-component hidden">
      <div class="component-background" @click="close" />
      <div class="wrapper no-scrollbar" :class="theme">
        <span class="close">
          <i class="fa fa-chevron-right fa-lg" @click="close" />
        </span>
        <span class="toggle" @click="triggerUpdateRoles">
          <i class="fa fa-redo" />
        </span>

        <div class="roles no-scrollbar" :style="wide">
          <div v-if="$store.getters.isSuperUser" class="column" @click="gotoClose('control')">
            <img src="/img/home2/unicorn.svg" />
            <p>{{ $t("roles.superuser") }}</p>
            <p v-show="showInfo" class="has-text-primary">
              {{ roleInfo("Superuser") }}
            </p>
          </div>
          <div v-if="$store.getters.isCommerceAgent" class="column" @click="gotoClose('ecommerce')">
            <img src="/img/home2/market.svg" />
            <p>{{ $t("roles.commerce-agent") }}</p>
            <p v-show="showInfo" class="has-text-primary">
              {{ roleInfo("Commerce Agent") }}
            </p>
          </div>
          <!-- <div
            v-if="$store.getters.isLogisticsAgent"
            class="column"
            @click="gotoClose('logistics_jobs')"
          >
            <img src="/img/home2/logistics2.svg" />
            <p>{{ $t("roles.logistics-agent") }}</p>
            <p v-show="showInfo" class="has-text-primary">
              {{ roleInfo("Logistics Agent") }}
            </p>
          </div> -->
          <div v-if="$store.getters.isDriver" class="column" @click="gotoClose('driver')">
            <img src="/img/home2/steering-wheel.svg" />
            <p>{{ $t("driver.driver") }}</p>
            <p v-show="showInfo" class="has-text-primary">
              {{ roleInfo("Driver") }}
            </p>
          </div>
          <!-- @click="gotoClose('dispatcher_jobs')" -->
          <!-- <div
            v-if="$store.getters.isDispatcher"
            class="column"
            @click="gotoClose('tuktuk')"
          > -->
          <div v-if="$store.getters.isDispatcher" class="column" @click="gotoClose('fleet_dispatcher')">
            <img src="/img/home2/phone.svg" />
            <p>{{ $t("driver.dispatcher") }}</p>
            <p v-show="showInfo" class="has-text-primary">
              {{ roleInfo("Dispatcher") }}
            </p>
          </div>
          <!-- <div
            v-if="$store.getters.isDeliveryManager"
            class="column"
            @click="gotoClose('driver')"
          >
            <img src="/img/home2/schedule.svg" />
            <p>{{ $t("Delivery Manager") }}</p>
            <p v-show="showInfo" class="has-text-primary">
              {{ roleInfo("Delivery Manager") }}
            </p>
          </div> -->
          <div v-if="$store.getters.isDeliveryDriver" class="column" @click="gotoClose('driver')">
            <img src="/img/home2/motorcycle.svg" />
            <p>{{ $t("Delivery Driver") }}</p>
            <p v-show="showInfo" class="has-text-primary">
              {{ roleInfo("Delivery Driver") }}
            </p>
          </div>
          <div v-if="$store.getters.isDeliveryDispatcher" class="column" @click="gotoClose('delivery')">
            <img src="/img/home2/food-delivery.svg" />
            <p>{{ $t("roles.delivery-dispatcher") }}</p>
            <p v-show="showInfo" class="has-text-primary">
              {{ roleInfo("Delivery Dispatcher") }}
            </p>
          </div>
          <!-- <div
            v-if="$store.getters.isAccountant"
            class="column"
            @click="gotoClose('/')"
          >
            <img src="/img/home2/budget.svg" />
            <p>{{ $t("roles.accountant") }}</p>
            <p v-show="showInfo" class="has-text-primary">
              {{ roleInfo("Accountant") }}
            </p>
          </div> -->

          <!------------------------- End of roles ----------------------->
          <div class="has-text-centered" style="margin-bottom: 10px" @click="triggerShowInfo">
            <!-- @click="triggerUpdateRoles" -->
            <!-- <img
              src="/img/home2/minus.svg"
              class="wiggle"
              style="width: 30px; padding: 0 0"
            /> -->
            <!-- <i class="far fa-window-minimize has-text-grey" /> -->
            <i class="fa fa-ellipsis-h has-text-grey" />
          </div>
        </div>

        <div class="status has-text-center">
          <i class="fa fa-bullhorn fa-lg is-pulled-left" :class="notificationsClass" @click="notify" />
          <i class="fa fa-signal fa-lg is-pulled-right" style="margin-right: 12px" :class="networkErrorsClass"
            @click="showSystemStats" />
          <!-- @click="showNetworkErrors = true" -->
        </div>

        <!-- <div v-if="showNetworkErrors" class="modal-background">SHOW</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from "../eventBus.js";
import { sounds } from "../functions.js";

export default {
  name: "WorkPanel",
  components: {},
  data() {
    return {
      // showNetworkErrors: false,
      showInfo: false,
    };
  },
  computed: {
    isSuper() {
      return this.$store.getters.isSuperUser;
    },
    notificationsClass() {
      if (!this.$store.state.user) return null;
      if (this.$store.getters.getNotificationToken) {
        return "has-text-success";
      }
      return "has-text-danger";
    },
    networkErrorsClass() {
      return "has-text-warning";
    },
    wide() {
      if (this.showInfo) return `width:auto; max-width:80vw`;
      return null;
    },
    theme() {
      return this.$store.state.theme;
    },
  },
  mounted() {
    EventBus.$on("CLOSE_HOME_PANELS", () => this.close());
  },
  methods: {
    close() {
      this.hideComponent(".work-panel-component");
    },
    gotoClose(path) {
      this.gotoDelay(path);
      setTimeout(() => this.close(), 1000);
    },
    triggerUpdateRoles() {
      this.updateRoles(true);
      this.infoToast("Updating roles <i class='fa fa-spinner fa-spin'></i>");
    },
    triggerShowInfo() {
      this.showInfo = true;
      setTimeout(() => (this.showInfo = false), 10 * 1000);
    },
    roleInfo(name) {
      var roles = this.$store.getters.getWorkerRoles;
      if (!roles) return;
      return roles
        .filter((r) => r.role_name === name)
        .map((r) => r.business.name)
        .join(", ");
    },
    notify() {
      if (!this.$store.state.user) {
        this.warningAlert("Please log in");
        return;
      }
      if (!this.$store.getters.getNotificationToken) {
        // this.warningAlert("Please check notification permission settings");
        this.$swal({
          title: "🤔",
          html: "Please check notification permission settings 📲",
          showCloseButton: true,
          showConfirmButton: true,
          showCancelButton: true,
          confirmButtonText: "Refresh App",
          cancelButtonText: "Clear Cache",
          cancelButtonColor: "orange",
        }).then((val) => {
          if (val.value) this.refreshPage();
          if (val.dismiss === "cancel") this.clearCacheAndReload();
        });
        return;
      }
      // otherwise success, notifications should be OK
      if (this.isSoundOn()) sounds("collect1");
      this.$swal({
        html: `<div style='text-align:left'>
          <p style='margin-bottom:12px'>👍🏼 sound: ${this.isSoundOn()}</p>
          <p style='font-size:0.8em; background-color:lightyellow; color:blue; padding:4px'>
            ${this.$store.getters.getNotificationToken}
          </p>
          </div>`,
        showCloseButton: true,
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Refresh App",
        cancelButtonText: "Clear Cache",
        cancelButtonColor: "orange",
      }).then((val) => {
        if (val.value) this.refreshPage();
        if (val.dismiss === "cancel") this.clearCacheAndReload();
      });
      setTimeout(() => {
        this.sendPushNotification("ขอบคุณเพื่อนของฉัน 🙏🏽", this.userID());
      }, 1500);
    },
  },
};
</script>

<style scoped>
.hidden {
  display: none;
}

.component-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.25);
  z-index: 2;
}

.wrapper {
  position: absolute;
  top: 0;
  right: 0;
  height: 100vh;
  /* if no roles should put a placeholder svg */
  min-width: 80px;
  backdrop-filter: blur(8px);
  background-color: rgba(255, 255, 255, 0.85);
  /* background-color: #333;
  color: white; */
  padding-bottom: 10px;
  padding-top: 14px;
  padding-left: 10px;
  padding-right: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.35);
  z-index: 4;
  /* display: none; */
  /* border-top-left-radius: 25px;
  border-bottom-left-radius: 25px; */
  /* overflow-x: auto; */
  /* white-space: nowrap; */
}

.dark {
  /* background-color: #1c37bd; */
  /* background-color: rgba(17, 34, 51, 0.8); */
  background-color: #1f1b24f3;
  color: white;
}

.column {
  /* display: inline-block; */
  /* width: 100px; */
  padding: 0 0;
  margin-bottom: 15px;
}

.column img {
  height: 60px;
}

.column p {
  margin-top: -5px;
}

.close {
  position: absolute;
  left: 4px;
  top: 0;
  /* margin-top: 8px;
  margin-right: 4px; */
  padding: 8px;
  /* color: #f5d252;
  text-shadow: 1px 0px 1px rgba(0, 0, 0, 0.5); */
}

.invisible {
  width: 100%;
  position: absolute;
  bottom: 0;
  right: 0px;
  padding: 25px;
  margin-bottom: 15px;
  opacity: 0.1;
  /* margin-right: 2px; */
}

.status {
  width: 100%;
  position: absolute;
  bottom: 0px;
  padding: 8px;
  margin-bottom: 10px;
}

.toggle {
  position: absolute;
  right: 0;
  top: 0;
  padding: 6px;
  opacity: 0.5;
}

.toggle img {
  height: 22px;
}

/* .wiggle:active {
  transform: rotate(330deg);
  -webkit-transform: rotate(330deg);
  -ms-transform: rotate(330deg);
} */
img:active {
  transform: scaleY(0.95);
}

.fa-chevron-right {
  opacity: 0.7;
}

.roles {
  overflow: scroll;
  max-height: calc(100vh - 110px);
  width: 100px;
  margin-top: 30px;
}
</style>